import { render, staticRenderFns } from "./PaperTable.vue?vue&type=template&id=69286a5c"
import script from "./PaperTable.vue?vue&type=script&lang=js"
export * from "./PaperTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69286a5c')) {
      api.createRecord('69286a5c', component.options)
    } else {
      api.reload('69286a5c', component.options)
    }
    module.hot.accept("./PaperTable.vue?vue&type=template&id=69286a5c", function () {
      api.rerender('69286a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaperTable.vue"
export default component.exports